import { SearchInput } from './SearchInput';
import * as S from './SearchInput.style';

export default SearchInput;
export const SearchInputStyle = S;
